import { Link } from "react-router-dom";

const stats = [
  { value: "120+", label: "午夜影片收录" },
  { value: "8.4", label: "平均评分" },
  { value: "7", label: "覆盖类型" },
  { value: "每晚", label: "更新推荐" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-6 lg:px-10">
      <div className="grid grid-cols-1 gap-10 rounded-lg border border-background-200/80 bg-background-100 p-6 md:p-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-400">
            <span className="h-1 w-6 rounded-full bg-primary-500" />
            关于本站
          </span>
          <h2 className="mb-4 font-heading text-2xl font-extrabold leading-snug text-foreground-50 md:text-3xl">
            为醒着的人，挑选这一夜的电影
          </h2>
          <p className="mb-4 text-sm leading-relaxed text-foreground-500">
            “午夜场的电影”是一个专注午夜档影片推荐与影视资讯的内容平台。
            我们把影片按类型、地区、年份整理归档，并附上剧情梗概与午夜观影建议，
            帮助你用更短的时间，找到更适合此刻情绪的那一部作品。
          </p>
          <p className="mb-7 text-sm leading-relaxed text-foreground-500">
            站内所有内容均为演示数据，方便你体验浏览、筛选、搜索与收藏的完整流程，
            正式上线时可直接替换为真实片库数据。
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200/80 bg-background-50 p-5 text-center"
            >
              <p className="font-heading text-3xl font-extrabold text-primary-400">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}